import { render, staticRenderFns } from "./project-list.vue?vue&type=template&id=5be5f06e&scoped=true&"
import script from "./project-list.vue?vue&type=script&lang=ts&"
export * from "./project-list.vue?vue&type=script&lang=ts&"
import style0 from "./project-list.vue?vue&type=style&index=0&id=5be5f06e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be5f06e",
  null
  
)

export default component.exports